/* eslint-disable @typescript-eslint/no-explicit-any */

import { LOG_LEVELS } from '../../config/logs';
import { createFrontendLogger } from './FrontendLogger';

// Use environment variable instead of next/config (App Router compatible)
const getStore = () => {
  if (typeof process !== 'undefined' && process.env.NEXT_PUBLIC_STORE) {
    return process.env.NEXT_PUBLIC_STORE;
  }
  return 'unknown';
};

const store = getStore();
const legacyLogger = createFrontendLogger(`storefront-legacy-${store}`);

const isLevelEnabled = (level: 'debug' | 'log' | 'warn' | 'error') => {
  if (LOG_LEVELS.includes(level)) {
    return true;
  }
  return false;
};

const formatLegacyMessage = (prefix: string, params: any[]) => {
  const rendered = params.map((param) => {
    if (param instanceof Error) {
      return `${param.name}: ${param.message}`;
    }

    if (typeof param === 'string') {
      return param;
    }

    try {
      return JSON.stringify(param);
    } catch {
      return String(param);
    }
  }).join(' ');

  return `${prefix} [${store}]${rendered ? ` ${rendered}` : ''}`;
};

export const Logger = {
  debug: (...params: any) =>
    isLevelEnabled('debug') &&
    legacyLogger.debug(formatLegacyMessage('Logger-Debug:', params)),
  log: (...params: any) =>
    isLevelEnabled('log') && legacyLogger.info(formatLegacyMessage('Logger-Log:', params)),
  warn: (...params: any) =>
    isLevelEnabled('warn') && legacyLogger.warn(formatLegacyMessage('Logger-Warn:', params)),
  error: (...params: any) => {
    if (!isLevelEnabled('error')) {
      return;
    }

    const firstError = params.find((param: any) => param instanceof Error);
    legacyLogger.error(
      formatLegacyMessage('Logger-Error:', params),
      firstError instanceof Error ? firstError : undefined,
    );
  },
};
